




























































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { api } from "../store";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../router/routenames";
import { Getter } from "vuex-class";
import { buildAnimator } from "../utils/animation";
import { buildAnimatorFirework } from "../utils/firework";
import { isString } from "lodash";
@Component({})
export default class DoKoHome extends Vue {
  count = 1;
  animatorId: number | null = null;
  readonly logosize = 356;

  get now() {
    const date = this.$route.query.now;
    console.log("NOW");
    if (isString(date) && !isNaN(Date.parse(date))) {
      return new Date(date);
    } else {
      return new Date();
    }
  }

  get isSilvester(): boolean {
    return (
      (this.now.getMonth() === 11 && this.now.getDate() === 31) ||
      (this.now.getMonth() === 0 && this.now.getDate() < 9)
    );
  }
  get isXMasTime(): boolean {
    return this.now.getMonth() === 11;
  }

  get logoImgId(): string {
    return this.isSilvester
      ? "bock"
      : this.isXMasTime
      ? "wildschwein-xmas"
      : "schwein";
  }

  get x(): number {
    return (1280 - this.logosize) / 2;
  }
  get y(): number {
    return 720 - 100 - this.logosize;
  }

  get actionRoute(): Location {
    return {
      name: this.isUserAuthenticated ? ROUTE_NAMES.LOBBY : ROUTE_NAMES.LOGIN,
    };
  }
  get actionText(): string {
    return this.isUserAuthenticated ? "Zur Lobby" : "Anmelden";
  }

  navigateToAction(): void {
    this.$router.push(this.actionRoute);
  }

  @Getter(api.getters.isUserAuthenticated)
  isUserAuthenticated!: boolean;

  mounted(): void {
    const canvas = this.$refs["actionFrame"] as HTMLCanvasElement | undefined;
    if (canvas) {
      this.animatorId = (this.isSilvester
        ? buildAnimatorFirework
        : buildAnimator)(canvas);
    }
  }

  destroyed(): void {
    if (this.animatorId !== null) {
      window.cancelAnimationFrame(this.animatorId);
      this.animatorId = null;
    }
  }
}
